export default "__VITE_ASSET__Cbu4m0Uh__"